import React, {Component} from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Button, Grid } from '@mui/material';

const LoadSessionContainer = (props) => {
  const host = process.env.API_URL;

  const handleSubmit = (event) => {
    event.preventDefault();
    const sessionId = event.target.elements.sessionId.value;
    const password = event.target.elements.password.value;

    props.onLoadSessionMap({
      dataUrl: `${host}/api/sessions/${sessionId}/map`,
      data: {
        password: password
      }
    });
  };

  return (
    <div>
      <form id="sessionForm" onSubmit={handleSubmit}>
        <Grid container direction="column">
          <Grid item style={{ paddingBottom: '10px' }}>
            <label htmlFor="sessionId">Session ID:</label>
            <input type="text" id="sessionId" name="sessionId" required/>
          </Grid>
          <Grid item style={{ paddingBottom: '10px' }}>
            <label htmlFor="password">Password:</label>
            <input type="text" id="password" name="password" required/>
          </Grid>
          <Grid item style={{ paddingBottom: '10px' }}>
            <Button variant="contained" type="submit" style={{textTransform: 'none'}}>Load Session</Button>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

export default LoadSessionContainer;